import { ReactSVG } from "react-svg";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import CustomButton from "../CustomButton";
import { Link } from "react-router-dom";
import LogoKrause from "../../assets/logo/logo-grupo-krause.png";
import UserIcon from "../../assets/icons/user-circle.svg";
import NavLink from "react-bootstrap/NavLink";
import "./Header.css";

export default function Header(props) {
  return (
    <Container className="header-container">
      <Row lg="auto" className="header-first-row">
        <Col xs={4} className="header-first-col">
          <a
            href={`https://wa.me/${props.whatsAppNumber}?text=Gostaria%20de%20iniciar%20atendimento%20do%20Grupo%20Krause.`}
            rel="noopener noreferrer"
            className="header-link"
            target="_blank"
          >
            <p>WhatsApp</p> <span>{props.whatsAppText}</span>
          </a>
        </Col>
        <Col xs={3} className="header-first-col">
          <a
            href="tel:05130369660"
            rel="noopener noreferrer"
            className="header-link"
          >
            <p>Atendimento 24h</p>
            <span>51 3036 9660</span>
          </a>
        </Col>
        <Col xs={5} className="header-first-col">
          <a
            href="tel:08000029600"
            rel="noopener noreferrer"
            className="header-link"
          >
            <p>Atendimento Funerário 24h</p>
            <span>0800 002 9600</span>
          </a>
        </Col>
      </Row>
      <Row className="header-second-row">
        <Navbar collapseOnSelect expand="lg" className="header-navbar">
          <NavLink as={Link} to="/" eventKey={1}>
            <img
              src={LogoKrause}
              alt="Logo Grupo Krause"
              className="header-logo"
            />
          </NavLink>
          <Navbar.Toggle aria-controls="responsive-navbar-nav">
            <span className="navbar-toggler-icon" />
            <div className="close-icon">✖</div>
          </Navbar.Toggle>
          <Navbar.Collapse
            id="responsive-navbar-nav"
            className="header-navbar-links"
          >
            <NavDropdown title="GRUPO KRAUSE" id="collapsible-nav-dropdown">
              <NavLink as={Link} to="/quem-somos/" eventKey={2}>
                O Grupo Krause
              </NavLink>
              <NavLink as={Link} to="/destaques/" eventKey={3}>
                Destaques
              </NavLink>
              <NavLink as={Link} to="/onde-estamos/" eventKey={4}>
                Onde Estamos
              </NavLink>
              <NavLink as={Link} to="/trabalhe-conosco/" eventKey={5}>
                Trabalhe Conosco
              </NavLink>
              <NavLink as={Link} to="/contato/" eventKey={6}>
                Contato
              </NavLink>
            </NavDropdown>
            <Nav>
              <NavLink
                as={Link}
                to="/servicos/funeraria-krause/"
                className="header-nav-link"
                eventKey={7}
              >
                FUNERÁRIA KRAUSE
              </NavLink>
              <NavLink
                as={Link}
                to="/servicos/krause-assistencial/"
                className="header-nav-link"
                eventKey={8}
              >
                KRAUSE ASSISTENCIAL
              </NavLink>
              <NavLink
                as={Link}
                to="/servicos/memorial-krause/"
                className="header-nav-link"
                eventKey={9}
              >
                MEMORIAL KRAUSE
              </NavLink>
              <NavLink
                as={Link}
                to="/servicos/mais-que-pet/"
                className="header-nav-link"
                eventKey={10}
              >
                MAIS QUE PET
              </NavLink>
              <NavLink
                as={Link}
                to="/servicos/pequenos-cometas/"
                className="header-nav-link"
                eventKey={11}
              >
                PEQUENOS COMETAS
              </NavLink>
              <CustomButton
                className="primary-btn-client"
                variant="primary"
                href="https://centraldocliente.grupokrause.com.br/login?redirect=/boletos"
                rel="noopener noreferrer"
                target="_blank"
                icon={<ReactSVG src={UserIcon} className="user-icon" />}
                content="CENTRAL DO CLIENTE"
                backgroundColor={props.btnColor}
                fontFamily="Unageo-Bold"
                fontColor={props.white}
                fontSize={12}
                Width=""
                borderColor={props.btnColor}
                disabled={false}
              />
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Row>
    </Container>
  );
}
